import React, { FC, ReactNode } from 'react';
import { 
  EventCardDate,
  EventCardContainer,
  EventCardImage,
  EventCardInfo,
  EventCardActions,
} from './components';

type EventCardProps = {
  children: ReactNode;
  className?: string;
};

const EventCard: FC<EventCardProps> & {
  Date: typeof EventCardDate;
  Container: typeof EventCardContainer;
  Image: typeof EventCardImage;
  Info: typeof EventCardInfo;
  Actions: typeof EventCardActions;
} = ({ children, className }) => {
  return (
    <div className={className}>{children}</div>
  );
};

EventCard.Date = EventCardDate;
EventCard.Container = EventCardContainer;
EventCard.Image = EventCardImage;
EventCard.Info = EventCardInfo;
EventCard.Actions = EventCardActions;

export { EventCard };